// extracted by mini-css-extract-plugin
export default {"form":"LoginPage_form__noceI","formGroup":"LoginPage_formGroup__mTcXo","noAccountLabel":"LoginPage_noAccountLabel__G0ys-"};